import React from 'react';
import { CiLocationOn } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { CiClock1 } from "react-icons/ci";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { CiFacebook } from "react-icons/ci";
import { MdOutlineEmail } from "react-icons/md";
import SITE from '../../../Data/siteConfig';
import "./TopNavbar.css";

const TopNavbar = () => {
  return (
    <>
      {/* Desktop top bar */}
      <div className='topbar topbar-desktop'>
        <div className="row">
          <div className="topbar-left">
            <div className="top-info">
              <div className='address-info'>
                <CiLocationOn className='icon-left' />
                <div className="icon-content">
                  <span>{SITE.address.district}, {SITE.address.city}</span>
                </div>
              </div>
              <div className='address-info'>
                <IoCallOutline className="icon-left" />
                <div className="icon-content">
                  <a href={SITE.phoneHref} className="topbar-link">{SITE.phoneDisplay}</a>
                </div>
              </div>
              <div className='address-info'>
                <CiClock1 className="icon-left" />
                <div className="icon-content">
                  <span>{SITE.workingHours}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="topbar-right">
            <div className="top-element">
              <ul className='socials'>
                <li>
                  <a href={SITE.social.instagram} target='_blank' rel="noopener noreferrer" aria-label="Instagram">
                    <FaInstagram className="icon-instagram" />
                  </a>
                </li>
                <li>
                  <a href={SITE.social.facebook} target='_blank' rel="noopener noreferrer" aria-label="Facebook">
                    <CiFacebook className="icon-facebook" />
                  </a>
                </li>
                <li>
                  <a href={SITE.whatsapp} target='_blank' rel="noopener noreferrer" aria-label="WhatsApp">
                    <FaWhatsapp className="icon-whatsapp" />
                  </a>
                </li>
                <li>
                  <a href={SITE.emailHref} aria-label="E-posta">
                    <MdOutlineEmail className="icon-email" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Mobil kompakt şerit */}
      <div className="topbar-mobile">
        <a href={SITE.phoneHref} className="topbar-mobile-phone">
          <IoCallOutline /> {SITE.phoneDisplay}
        </a>
        <span className="topbar-mobile-hours">{SITE.workingHours}</span>
      </div>
    </>
  );
};

export default TopNavbar;
